import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatSec'
})
export class FormatSecPipe implements PipeTransform {

  transform(value: number): string {
    let min = Math.floor(value / 60) < 10 ? `0${Math.floor(value / 60)}` : `${Math.floor(value / 60)}`;
    let sec = Math.floor(value % 60) < 10 ? `0${Math.floor(value % 60)}` : `${Math.floor(value % 60)}`;
    return min + '.' + sec;
  }

}
